import { UserHttpService } from 'src/app/http/user-http.service';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EventsService } from 'src/app/services/events.service';
import { Location } from '@angular/common';
import { CustomValidators } from 'ngx-custom-validators';

@Component({
    selector: 'app-user-new',
    templateUrl: './user-new.component.html',
    styles: [],
})
export class UserNewComponent implements OnInit {
    constructor(
        private fb: FormBuilder,
        public location: Location,
        private eventsService: EventsService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private userHttpService: UserHttpService
    ) {}

    password = new FormControl(null, [Validators.required, Validators.minLength(6)]) as any;

    newUserForm = this.fb.group(
        {
            firstName: [null, Validators.required],
            lastName: [null, Validators.required],
            userName: [null],
            email: [null, [CustomValidators.email, Validators.required]],
            newPassword: this.password,
            confirmPassword: [null, [CustomValidators.equalTo(this.password), Validators.required]],
            roles: ['branch'],
            branchId: [null, Validators.required],
            isEnabled: [true],
        },
        { updateOn: 'submit' }
    );

    formBusy: boolean;

    branches: any[] = [];

    isBranchRequired: boolean = true;

    ngOnInit(): void {
        this.routeData();
    }

    routeData() {
        this.activatedRoute.data.subscribe((data) => {
            this.branches = data.data;
        });
    }

    roleStateSub(ev: any) {
        if (ev.target.value === 'branch') {
            this.newUserForm.controls['branchId'].setValidators(Validators.required);
            this.newUserForm.controls['branchId'].updateValueAndValidity();
            this.isBranchRequired = true;
        } else if (ev.target.value === 'admin') {
            this.newUserForm.controls['branchId'].clearValidators();
            this.newUserForm.controls['branchId'].updateValueAndValidity();
            this.isBranchRequired = false;
        }
    }

    onSubmit() {
        this.newUserForm.markAsTouched();
        if (this.newUserForm.valid) {
            this.formBusy = true;
            this.newUserForm.value.roles = [this.newUserForm.value.roles];
            this.newUserForm.value.userName = this.newUserForm.value.email;
            this.userHttpService.newUser(this.newUserForm.value).subscribe(
                () => {
                    this.router.navigateByUrl('user-list', {
                        state: { hasState: true, type: 'success', message: 'User Created successfully' },
                    });
                },
                () => {
                    this.formBusy = false;
                    this.newUserForm.setErrors({ exists: true });
                }
            );
        }
    }

    ngOnDestroy(): void {
        this.eventsService.trigger.next({ name: null, value: null });
    }
}
